import React from 'react';
import * as PropTypes from 'prop-types';
//import { Card, Header } from 'semantic-ui-react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

import * as chartConfigs from './chartConfigBase';

const SankeyChartComponent = ({ data }) => {
    const createChartConfig = () => {
        return Object.assign(
            {},
            chartConfigs.sankey,
            {
                series: data,
            },
            { exporting: { enabled: false } },
        );
    };

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={createChartConfig()}
        />
    );
};

SankeyChartComponent.propTypes = {
    data: PropTypes.array,
};

export default SankeyChartComponent;
